import React from "react";
import { EditorTools } from "@progress/kendo-react-editor";
import { JSX } from "react/jsx-runtime";
import styled from "styled-components";

const { FormatBlock } = EditorTools;

const StyledCustomFormatBlock = styled.div`
  .custom-format-block-aligned {
    position: relative;
  }
  .custom-format-block-aligned .k-input-inner {
    color: transparent !important; /* Make text transparent instead of hiding */
    background: transparent !important;
    text-indent: -9999px !important; /* Push text out of view */
  }
  .custom-format-block-aligned .k-input-value-text {
    color: transparent !important; /* Make value text transparent */
    text-indent: -9999px !important; /* Push text out of view */
  }
  .custom-format-block-aligned .k-svg-icon {
    position: absolute !important;
    left: -27px !important; /* Position SVG closer to the left edge */
    top: 50% !important;
    transform: translateY(-50%) !important;
    z-index: 10 !important;
  }
  /* Force dropdown arrow to appear - Kendo style */
  .custom-format-block-aligned::after {
    content: "" !important;
    position: absolute !important;
    right: 10px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: 0 !important;
    height: 0 !important;
    border-left: 4px solid transparent !important;
    border-right: 4px solid transparent !important;
    border-top: 6px solid #000000 !important;
    pointer-events: none !important;
    z-index: 5 !important;
  }
`;

/**
 * Custom FormatBlock component with 64px button width and custom format icon
 * Provides format block selection functionality for the WYSIWYG editor
 * Matches the width of ForeColor tool with a custom typography-style icon
 * Includes dropdown arrow for better UX
 */

// Custom SVG icon for the FormatBlock button - letter 'A' for typography
// Following Kendo's SVGIcon interface with name, content, and viewBox
const customFormatBlockIcon = {
  name: "format-block",
  content:
    '<path d="M560-160v-520H360v-120h520v120H680v520H560Zm-360 0v-320H80v-120h360v120H320v320H200Z"/>',
  viewBox: "0 -960 960 960"
};

export const CustomFormatBlock = (
  props: JSX.IntrinsicAttributes & EditorTools.FormatBlockProps
) => (
  <StyledCustomFormatBlock>
    <FormatBlock
      {...props}
      // Additional props to override any Kendo defaults
      className={`${props.className || ""} custom-format-block-aligned`}
      // Custom popup settings for wider dropdown
      popupSettings={{
        ...props.popupSettings,
        width: "180px" // Wide enough for "Heading 1", "Heading 2", etc.
      }}
      // 64px button width to match ForeColor tool
      style={{
        ...props.style,
        width: "60px", // Match ForeColor tool button width
        minWidth: "60px", // Prevent button from shrinking
        position: "relative" // Enable absolute positioning for icon
      }}
      // Custom SVG icon for the button
      svgIcon={customFormatBlockIcon}
    />
  </StyledCustomFormatBlock>
);

export default CustomFormatBlock;
